import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Kissybook",
  "description": "",
  "published": "2007-02-26T00:00:00.000Z",
  "redirect_from": ["/blog/kissybook/swizec/279"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><a parentName="p" {...{
        "href": "http://kissybook.net"
      }}>{`The Kissybook`}</a>{` is a colaborative art project that seems like a really cool idea, which is why I drew this `}<a parentName="p" {...{
        "href": "http://www.deviantart.com/deviation/49689143/"
      }}>{`cute little bunny`}</a>{` in hopes of being included in the book. We'll see how it goes, I'll be sure to buy a copy, or a few, if I get in.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      